import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import CreateProject from "./Tabs/CreateProject";
import ProjectHistory from "./Tabs/ProjectHistory";
import { useTranslation } from "react-i18next";

const Project = () => {
  const [currentTab, setCurrentTab] = useState("createProject");
  const { t } = useTranslation();

  return (
    <>
      <Row
        className={"tab-container-single-line text-20 text-color-gray-light fw-semibold"}
        style={{ height: "40px", margin: "0 12px 12px 12px" }}
      >
        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100  ${currentTab === "createProject" && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => {
              setCurrentTab("createProject");
            }}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              <span className={"d-none d-md-inline"}>{t("createProjectTabLabel")} </span>
              <span className={"d-md-none"}>{t("createTabShortLabel")}</span>
            </Col>
          </Row>
        </Col>

        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100  ${currentTab === "projectHistory" && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => {
              setCurrentTab("projectHistory");
            }}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              <span className={"d-none d-md-inline"}>{t("projectHistoryTabLabel")}</span>
              <span className={"d-md-none"}>{t("historyTabShortLabel")}</span>
            </Col>
          </Row>
        </Col>
      </Row>

      {currentTab === "createProject" && <CreateProject />}
      {currentTab === "projectHistory" && <ProjectHistory />}
    </>
  );
};

export default Project;
